import CustomNavigationBar from "@memorang/ui/src/components/CustomAppbar";
import EmptyState from "@memorang/ui/src/components/EmptyView";
import ProgressView from "@memorang/ui/src/components/ProgressApplet/ProgressView";
/* -----------------Assets--------------- */
import ProgressEmptySvg from "@memorang/ui/src/components/ProgressApplet/progress-empty-state.svg";
import type {
	ExamCardData,
	MasteryTagProgressData,
	SummaryCardData,
} from "@memorang/ui/src/components/ProgressApplet/types";
import ScrollContainer from "@memorang/ui/src/components/ScrollContainer";
import { useDevice } from "@memorang/ui/src/useDevice";
import type { ImageSourcePropType } from "react-native";
import type { CustomNavigationBarProps } from "../CustomAppbar/types";

const ProgressApplet = ({
	showPracticeTests,
	handleClickCard,
	showStudyPackViews,
	handleClickStudy,
	appFont,
	handleNavigation,
	progressNeedsImprovementCtaLabel,
	emptyState,
	masteryTagsProgressData,
	needsImprovementProgressData,
	progressPageSummaryCardData,
	practiceTestsCardsData,
	showEmptyState,
	weakTagIds,
	handleClickInfo,
	CustomAppBar,
}: {
	showPracticeTests?: boolean;
	handleClickCard: (title: string) => void;
	showStudyPackViews?: boolean;
	handleClickStudy: (tagIds: string[]) => void;
	appFont: string;
	handleNavigation: (numericId: number) => void;
	progressNeedsImprovementCtaLabel: string;
	emptyState: {
		title: string;
		subtitle: string;
		cta: string;
		onAction?: () => void;
	};
	masteryTagsProgressData: MasteryTagProgressData[];
	needsImprovementProgressData: MasteryTagProgressData | null;
	progressPageSummaryCardData?: SummaryCardData;
	practiceTestsCardsData?: ExamCardData;
	showEmptyState: boolean;
	handleClickInfo: (text: string, title: string) => void;
	weakTagIds: string[];
	CustomAppBar: CustomNavigationBarProps;
}) => {
	const { isMediumWindowSize } = useDevice();
	const { isMobile } = useDevice();

	return (
		<>
			<CustomNavigationBar
				mode={isMobile ? "small" : "medium"}
				align={CustomAppBar.align ?? "flex-start"}
				showCommandBar={CustomAppBar.showCommandBar}
				showSettings={CustomAppBar.showSettings}
				showUserMenu={CustomAppBar.showUserMenu}
				renderSearchbar={CustomAppBar.renderSearchbar}
				options={{
					headerTitle: CustomAppBar.options?.headerTitle,
					subtitle: CustomAppBar.options?.subtitle,
					headerRight: CustomAppBar.options?.headerRight,
					headerLeft: CustomAppBar.options?.headerLeft,
				}}
				handleFeedbackNavigation={CustomAppBar.handleFeedbackNavigation}
				onAvatarPress={CustomAppBar.onAvatarPress}
				onBackPress={CustomAppBar.onBackPress}
				toggleShowFeedbackDialog={CustomAppBar.toggleShowFeedbackDialog}
				onHamburgerMenuPress={CustomAppBar.onHamburgerMenuPress}
				userInfo={CustomAppBar.userInfo}
				trackCustomEvent={CustomAppBar.trackCustomEvent}
				toggleCommandbar={CustomAppBar.toggleCommandbar}
				handleTrackEvent={CustomAppBar.handleTrackEvent}
				back={CustomAppBar.back}
				stats={CustomAppBar.stats}
				breadcrumbs={CustomAppBar.breadcrumbs}
				showHambugerMenu={CustomAppBar.showHambugerMenu}
				accessible
				accessibilityLabel={CustomAppBar.accessibilityLabel}
			/>
			<ScrollContainer
				contentContainerStyle={{ padding: 16 }}
				maxWidth={isMediumWindowSize ? "sm" : "md"}
				// biome-ignore lint/a11y/useSemanticElements: <explanation>
				role="main"
			>
				{showEmptyState ? (
					<EmptyState
						title={emptyState.title}
						subtitle={emptyState.subtitle}
						cta={emptyState.cta}
						image={ProgressEmptySvg as ImageSourcePropType}
						handleAction={emptyState.onAction}
					/>
				) : (
					<ProgressView
						masteryTagsProgressData={masteryTagsProgressData}
						needsImprovementProgressData={needsImprovementProgressData}
						summaryCardData={progressPageSummaryCardData}
						practiceTestsCardData={practiceTestsCardsData}
						showStudyPackViews={showStudyPackViews}
						showPracticeTests={showPracticeTests}
						handleClickCard={handleClickCard}
						handleClickStudy={() => handleClickStudy(weakTagIds)}
						appFont={appFont}
						handleNavigation={handleNavigation}
						progressNeedsImprovementCtaLabel={progressNeedsImprovementCtaLabel}
						handleClickInfo={handleClickInfo}
					/>
				)}
			</ScrollContainer>
		</>
	);
};

export default ProgressApplet;
